import React, { useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { Checkbox } from '@material-ui/core';
import { SliderPartialRequestWithLabel } from '../SliderPartialRequest';
import './ListSelect.scss';
const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    paddingTop: '4px',
  },
  checkbox: {
    borderRadius: '10px'
  },
}));

const BoldedListItemText = withStyles({
  primary: {
    fontWeight: 'Bold',
    display: 'block'
  }
})(ListItemText)


/**
 * @typedef {Object} shiftObject
 * @property {int} id the Id of the shift
 * @property {string} shiftTime (Primary text) the time of the shift  
 * @property {string} primaryJob (Secondary Text) the primary job of the shift 
 * @property {string} shiftDate (Secondary action near end of text) the date of the shift 
 * /
/**
 * @brief Create a list with selection
 * 
 * @param {React.props} props 
 * @property {array} shiftsArray an array of shiftObject. 
 * @property {int} limit max number of checkboxes allowed to use 
 * @property {function} limitHandler handler passed when max checkboxes are used
 */
export default function ListSelect(props) {
  const classes = useStyles();
  const { shiftsArray, isPartialEnabledInSetting = false, offeredShiftsCount, sliderPartialRequestWithLabelProps } = props;
  const [checked, setChecked] = React.useState(props.selection);
  const isSingleShift = offeredShiftsCount === 1;
  const isChecked = (shift) => checked.indexOf(shift.id) !== -1;
  const isPartialAllowed = isPartialEnabledInSetting && isSingleShift;
  
  useEffect(() => setChecked(props.selection), [props.selection])

  const handleToggle = value => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
    props.handlerUpdateState(newChecked);
  };

  return (
    <List className={classes.root} dense={true}>
      {
        shiftsArray.length > 0 ? shiftsArray.map((shift) =>
          <ListItem key={shift.id} className="ls-list-item" >
            <ListItemIcon className="ls-checkbox">
              <Checkbox
                onClick={() => handleToggle(shift.id)}
                checked={isChecked(shift)}
                color='primary'
                disabled={checked.length >= offeredShiftsCount && !isChecked(shift)}
              />
            </ListItemIcon>
            <BoldedListItemText
              key={shift.id}
              primary={
                <div className="ls-shiftDateTime-container">
                  <span className="ls-shiftHours">{`${shift.label ?? ""} ${shift.shiftTime}`}</span>
                  <span className="ls-shiftDate">{shift.shiftDate}</span>
                </div>}
              secondary={<ProposalListItemContent
                shift={shift}
                isPartialAllowed={isPartialAllowed}
                isChecked={isChecked(shift)}
                sliderPartialRequestWithLabelProps={sliderPartialRequestWithLabelProps} />
              }
            />
          </ListItem>
        )
          :
          <div style={{ color: '#ededed', paddingTop: 10 }}>None available</div>
      }
    </List>
  )
};

const ProposalListItemContent = ({ shift, isPartialAllowed, isChecked, sliderPartialRequestWithLabelProps }) => (
  <>
    {shift.primaryJob}
    {isPartialAllowed && isChecked && (
      <SliderPartialRequestWithLabel
        shifts={[shift]}
        {...sliderPartialRequestWithLabelProps}
      />
    )}
  </>
)